var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditSection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9066 9.13436L11.7003 8.34069C11.8243 8.21668 12.0401 8.30349 12.0401 8.48206V12.0883C12.0401 12.7455 11.5068 13.2788 10.8496 13.2788H2.11921C1.46196 13.2788 0.928711 12.7455 0.928711 12.0883V3.35794C0.928711 2.70069 1.46196 2.16744 2.11921 2.16744H8.90259C9.07869 2.16744 9.16798 2.38074 9.04397 2.50723L8.2503 3.3009C8.2131 3.3381 8.16349 3.35794 8.10893 3.35794H2.11921V12.0883H10.8496V9.27325C10.8496 9.22117 10.8694 9.17156 10.9066 9.13436ZM14.7906 4.12929L8.27758 10.6423L6.03547 10.8904C5.38565 10.9623 4.83257 10.4141 4.90449 9.75937L5.15251 7.51726L11.6656 1.00422C12.2335 0.436255 13.1512 0.436255 13.7167 1.00422L14.7881 2.07568C15.3561 2.64364 15.3561 3.5638 14.7906 4.12929V4.12929ZM12.3402 4.89568L10.8992 3.45467L6.29093 8.06539L6.10987 9.68497L7.72945 9.50391L12.3402 4.89568ZM13.9473 2.91895L12.8759 1.8475C12.7742 1.74581 12.608 1.74581 12.5088 1.8475L11.7424 2.61388L13.1834 4.05488L13.9498 3.2885C14.049 3.18433 14.049 3.02064 13.9473 2.91895V2.91895Z",
    fill: "current",
    stroke: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSection);
export default __webpack_public_path__ + "static/media/edit-section.73e9f1e1.svg";
export { ForwardRef as ReactComponent };